import { EVENTS } from '../../../bus/events.const';
import { COMPONENTS } from '../../../components/components.registry';
import { ResultsGridConfig } from '../../../models';

export const DEFAULT_RESULTS_GRID_CONFIG: ResultsGridConfig = {
  components: {
    grid: COMPONENTS.PURE.DefaultGrid,
    gridColumnsPicker: COMPONENTS.PURE.IconColumnsPicker,
    gridItem: {
      Banner: COMPONENTS.PURE.DefaultBanner,
      Promoted: COMPONENTS.SMART.Promoted,
      Result: COMPONENTS.SMART.ConfigurableResult,
      NextQueries: COMPONENTS.SMART.NextQueries
    },
    promoted: {
      wrapper: COMPONENTS.PURE.DefaultPromoted,
      fallbackImage: COMPONENTS.PURE.BrokenImageIcon
    },
    nextQueries: {
      withResults: COMPONENTS.PURE.NextQueryResults,
      withoutResults: COMPONENTS.PURE.NextQuery
    }
  },
  clickEvents: {
    Banner: {
      click: EVENTS.BannerClicked,
      rightClick: EVENTS.BannerRightClicked
    },
    NextQueries: {
      click: EVENTS.ResultClickedWithQueryTracking,
      rightClick: EVENTS.ResultRightClicked
    },
    Promoted: {
      click: EVENTS.PromotedClicked,
      rightClick: EVENTS.PromotedRightClicked
    },
    Result: {
      click: EVENTS.ResultClicked,
      rightClick: EVENTS.ResultRightClicked
    }
  },
  pageSize: 24,
  grid: {
    columns: 2,
    columnsPicker: [6, 2],
    stagger: 45
  }
};
